import React, { FC } from 'react';
import { IAccount } from '../../store/merchnts/merchant-interfaces';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import clsx from 'clsx';

interface Props extends IAccount {
	onEdit?: (account: IAccount) => void;
	isAccountPage?: boolean;
}

export const AccountTableRow: FC<Props> = (props) => {
	const { onEdit, isAccountPage, ...account } = props;
	const navigate = useNavigate();
	const { pathname } = useLocation();
	return (
		<tr>
			<td>
				<div
					className={clsx('fs-6', isAccountPage && 'cursor-pointer')}
					onClick={(): void => isAccountPage && navigate(`${pathname}/${account?.id}`)}
				>
					{account?.name}
				</div>
			</td>
			<td>{account?.applications?.length}</td>
			<td>{account?.merchants?.length}</td>
			<td>
				<div
					className="d-flex align-items-center cursor-pointer text-muted"
					onClick={(): void => onEdit(account)}
				>
					<FontAwesomeIcon icon={faPenToSquare}/>
					<span className="fs-7 fw-bolder ms-2">
						Edit
					</span>
				</div>
			</td>
		</tr>
	);
};
